//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Clipboard from 'clipboard';
export default {
  props: ['modelProp', 'parentpage', 'acceptName', 'bg', 'color'],
  data() {
    return {
      baiduCount: '',
      list: [],
      wx: 'wx',
      phone: 'tel000',
    };
  },
  watch: {
    'modelProp.gid': {
      handler: function (n) {
				if(!n) return
        console.log('获取测算gid',n);
        this.getHot();
        this.getService();
      },
      deep: true,
			immediate:true
    },
  },
  methods: {
    //  复制微信
    copyWecat() {
      this.$Glb.baiduCount(`${this.baiduCount}微信客服`);

      let _this = this;
      var clipboard = new Clipboard('.copy_wx_btn');
      clipboard.on('success', (e) => {
        _this.$Glb.PlMessage('复制成功', 800, function () {
          window.location.href = 'weixin://';
        });
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on('error', (e) => {
        // 不支持复制
        _this.$Glb.PlMessage('该浏览器不支持一键复制,请长按手动复制', 800);
        // 释放内存
        clipboard.destroy();
      });
    },
    baiduTongji(text) {
      var page = '首页';
      if (this.modelProp.type == 2) {
        page = '结果页';
      } else if (this.modelProp.type == 3) {
        page = '解锁页';
      }
      this.$Glb.baiduCount(page + text);
    },

    getHot() {
      let data = {
        gid: this.modelProp.gid,
        type: this.modelProp.type, //page1=1，page2=3，page3=2
        posId: this.$Glb.getAttribute().posId,
        qd: this.$Glb.getAttribute().qd,
        userId: '',
        deviceId: '',
      };
      this.$api.post('/v1/Relationproduct/index', data, (res) => {
        this.list = res.data;
      });
    },
    async getService() {
      localStorage.GLB_ROOT_USER_GOODSID = this.modelProp.gid;
      localStorage.GLB_ROOT_QD = this.$Glb.getAttribute().qd || this.modelProp.qd;
      let data = {
        isWnl: 2,
        goodsid: this.modelProp.gid,
        page: this.modelProp.type, //1（首页）， 2（详情页），3（未解锁页）
        cid: this.$Glb.getAttribute().qd || this.modelProp.qd,
      };
      // let data = {
      //   isWnl: 2,
      //   goodsid: '1000013',
      //   page: 2, //1（首页）， 2（详情页），3（未解锁页）
      //   cid: 'wx',
      // };
      let res = await this.$getWxPhone(data);
			console.log('res',res)
      this.wx = res.data.wechat || this.wx;
      this.phone = res.data.phone || this.phone;
      this.$store.commit('setWx', res.data.wechat || 'wx');
      this.$store.commit('setPhone', res.data.phone || 'phone');
      this.$store.commit('setShowTop', (res.data.showTop == 1 ? true : false) || false);
      this.$store.commit('setShowMiddle', (res.data.showMiddle == 1 ? true : false) || false);
      this.$store.commit('setShowBottom', (res.data.showBottom == 1 ? true : false) || false);
    },
  },
  created() {
    console.log('子组件', this.modelProp);
    // if (this.modelProp.gid) this.getService();
    //
  },
};



// WEBPACK FOOTER //
// ./src/components/footer.vue